/**
 * Kaleidoscope painting, shared by the Mirror toy and by the snapshot renderer
 * that makes thumbnails and exports. It lives in the engine rather than in the
 * toy because a saved pattern has to be redrawable without the toy on screen.
 *
 * Strokes arrive already relative to the centre of the fold, so the same data
 * redraws at any canvas size — which is what makes a pattern drawn on a phone
 * reopen correctly on a laptop.
 */

import type { Stroke } from './stroke.ts';
import { drawStroke } from './render.ts';

/** The caller has already translated (and scaled) the context to the centre. */
export function paintMirrored(ctx: CanvasRenderingContext2D, stroke: Stroke, folds: number, flip: boolean): void {
  for (let i = 0; i < folds; i++) {
    ctx.save();
    ctx.rotate((i / folds) * Math.PI * 2);
    drawStroke(ctx, stroke);
    if (flip) {
      ctx.scale(1, -1);
      drawStroke(ctx, stroke);
    }
    ctx.restore();
  }
}

/** How far the pattern reaches from the centre — its bounding circle. */
export function mirrorRadius(strokes: Stroke[]): number {
  let r = 0;
  for (const s of strokes) {
    for (const p of s.points) r = Math.max(r, Math.hypot(p.x, p.y) + s.width);
  }
  return r;
}
